<template>
    <div id="checkout-component" class="d-flex justify-content-center align-items-center vh-100-desktop">
        <div class="container" style="background: #fafafa">
            <div class="row">
                <div class="col-12 col-sm-6 noPaddingLeft">
                    <img style="width: 100%" src="/images/checkout/img_checkout.jpg" alt="">
                </div>

                <!-- Pantalla de pago confirmado -->
                <div id="paymentConfirmed" class="col-12 col-sm-6 d-flex justify-content-center align-items-center"
                    v-if="isPaymentConfirmed">
                    <div
                        class="content-wrapper d-flex flex-column justify-content-center align-items-center text-center">
                        <h2>¡Gracias por tu pago!</h2>
                        <p>Pronto recibirás un correo de la confirmación.</p>
                        <p>Nos pondremos en contacto a la brevedad posible.</p>
                    </div>
                </div>

                <!-- Pantalla de cotización y pago -->
                <div id="quoter" v-else class="col-12 col-sm-6">
                    <!-- Encabezado con datos del cliente -->
                    <div class="header mt-4">
                        <h1 class="blueText">
                            <strong style="font-size: 24px;">¡Hola!,</strong> <br>
                            {{ quoter.nom_cont }} {{ quoter.paterno }} {{ quoter.materno }}
                        </h1>
                        <p><strong>Esta es tu cotizacion que aun esta vigente</strong></p>
                    </div>

                    <!-- Información de la cotización -->
                    <div class="datos-generales">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-6 text-left">
                                <strong>Correo:</strong><br>
                                <span>{{ quoter.email }}</span>
                            </div>
                            <div class="col-12 col-sm-6 text-left mb-4">
                                <strong>Teléfono:</strong><br>
                                <span>{{ quoter.telefono }}</span>
                            </div>
                            <div class="col-12 col-sm-6 text-left mb-4">
                                <strong>Paquete:</strong><br>
                                <span>{{ quoter.relpackage.paquete }}</span>
                            </div>
                            <div class="col-12 col-sm-6 text-left">
                                <strong>Plan:</strong><br>
                                <span>{{ quoter.reltipoplan.plan }}</span>
                            </div>
                            <div class="col-12 col-sm-6 text-center">
                                <div class="total_amount">
                                    <strong>TOTAL:</strong>
                                    <span>{{ quoter.prima_total }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Aceptación de términos -->
                    <div class="terms-container d-flex align-items-start">
                        <input type="checkbox" id="terms" v-model="acceptedTerms" @change="showTerms"
                            class="me-2 mt-1 flex-shrink-0">
                        <label
                            style="background:transparent !important; margin-bottom: 0; line-height: 1.2; font-size: 14px;"
                            for="terms">
                            Acepto los términos y condiciones, click para continuar...
                        </label>
                    </div>

                    <!-- Formulario de tarjeta -->
                    <div id="details" v-show="acceptedTerms && availablePlans.length === 0">
                        <input id="cardholder-name" type="text" placeholder="Nombre del Tarjetahabiente"
                            ref="cardholderName">
                        <form id="payment-form" @submit.prevent="handleSubmit">
                            <div id="card-element"></div>
                            <button id="card-button" class="formSubmit">Validar MSI</button>
                        </form>
                    </div>

                    <!-- Formulario de planes de cuotas -->
                    <div id="plans" v-if="availablePlans.length">
                        <form id="installment-plan-form" @submit.prevent="confirmPaymentWithPlans" class="row">
                            <input type="hidden" id="payment-intent-id" v-model="intentId" />

                            <!-- Opciones de MSI -->
                            <div v-for="(plan, idx) in availablePlans" :key="idx" class="col-12 col-sm-3">
                                <div class="month mb-2">
                                    <input type="radio" :value="idx" v-model="selectedPlan" /> <br>
                                    {{ plan.count }} {{ plan.interval }}s <br>
                                    <span class="mensualidad">{{ calculateTotalAmount(plan.count) | currency }}</span>
                                </div>
                            </div>

                            <!-- Opción de pago de contado -->
                            <div class="col-12 col-sm-3">
                                <div class="month mb-2">
                                    <input type="radio" :value="'cash'" v-model="selectedPlan" /> <br>
                                    Pago de contado <br>
                                    <span class="mensualidad">
                                        {{ calculateCashPayment(this.totalAmount) | currency }}
                                    </span>
                                </div>
                            </div>

                            <!-- Botones de acción -->
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <button v-if="!showDetails" @click="changeCard" class="formSubmit">
                                        Cambiar de tarjeta
                                    </button>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <button type="submit" class="formSubmit" :disabled="isConfirmingPayment">
                                        <span v-if="isConfirmingPayment">Procesando... <i class="fa fa-spinner fa-spin"></i></span>
                                        <span v-else>Confirmar Pago</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import sweetAlert from 'sweetalert2';
import { apiKeyService } from "../../Services/ApiKey.service";
import { legalService } from "../../Services/Legal.service";
import { myMixins } from "../mixins/myMixins";

// Configuración de pagos
const PAYMENT_CONFIG = {
    STRIPE: {
        PERCENTAGE: 0.036, // 3.6%
        FIXED_FEE: 3, // 3 MXN
        TAX_RATE: 0.16, // IVA 16%
        MSI_PERCENTAGES: {
            3: 0.05,   // 5% para 3 meses
            6: 0.075,  // 7.5% para 6 meses
            9: 0.10,   // 10% para 9 meses
            12: 0.125  // 12.5% para 12 meses
        }
    },
    COOKIE_EXPIRY: 0.5 // Media hora (en días)
};

export default {
    name: "checkout",
    mixins: [myMixins],

    props: {
        quoter: {
            type: Object,
            required: true
        },
        qrcode: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isPaymentConfirmed: false,
            isLoading: false,
            isConfirmingPayment: false,
            stripe: null,
            cardElement: null,
            totalAmount: 0,
            paymentMethodId: null,
            availablePlans: [],
            intentId: '',
            selectedPlan: null,
            showDetails: true,
            acceptedTerms: false,
            terms: '',
        }
    },

    filters: {
        currency(value) {
            return new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN'
            }).format(value);
        }
    },

    mounted() {
        this.initializeStripe();
        this.loadTermsAndConditions();
    },

    methods: {
        // Inicialización y configuración
        async initializeStripe() {
            try {
                const stripeInfo = await apiKeyService.getMany();
                this.stripe = Stripe(stripeInfo.value);
                //console.log("Stripe configurado correctamente", stripeInfo);

                const elements = this.stripe.elements();
                this.cardElement = elements.create('card');
                this.cardElement.mount('#card-element');
            } catch (error) {
                console.error("Error configurando Stripe:", error);
            }
        },

        async loadTermsAndConditions() {
            try {
                const response = await legalService.getOne(3);
                this.terms = response.info;
            } catch (error) {
                console.error("Error cargando términos:", error);
            }
        },

        // Gestión de cookies
        setPaymentCookie(quoter = null, totalAmount = null) {
            let paymentQuoter = Cookies.get('payment_quoter')
                ? JSON.parse(Cookies.get('payment_quoter'))
                : {};

            if (quoter) {
                paymentQuoter = {
                    id: quoter.id,
                    name: `${quoter.nom_cont} ${quoter.paterno} ${quoter.materno}`,
                    email: quoter.email,
                    phone: quoter.telefono,
                    package: quoter.relpackage.paquete,
                    plan: quoter.reltipoplan.plan,
                };
            }

            if (totalAmount !== null) {
                paymentQuoter.amount = Math.round(totalAmount);
            }

            Cookies.set('payment_quoter', JSON.stringify(paymentQuoter), {
                expires: PAYMENT_CONFIG.COOKIE_EXPIRY,
                path: '/',
                sameSite: 'lax'
            });
        },

        // UI Handlers
        async showTerms() {
            if (this.acceptedTerms) {
                const result = await sweetAlert.fire({
                    title: 'Términos y Condiciones',
                    html: '<div style="border:1px solid #ccc;max-height: 400px; overflow-y: auto; padding: 15px;">' + this.terms + '</div>',
                    width: '80%',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar'
                });

                this.acceptedTerms = result.isConfirmed;
            }
        },

        changeCard() {
            this.showDetails = true;
            this.availablePlans = [];
        },

        // Cálculos de pagos
        calculateTotalAmount(months) {
            const { STRIPE } = PAYMENT_CONFIG;
            const { PERCENTAGE, FIXED_FEE, TAX_RATE, MSI_PERCENTAGES } = STRIPE;

            // Validar meses
            if (!months || !MSI_PERCENTAGES[months]) {
                console.error(`Error: El número de meses (${months}) no es válido`);
                return null;
            }

            // Obtener porcentaje MSI
            const msiRate = Number(MSI_PERCENTAGES[months]);

            // Calcular comisión Stripe
            const stripeFee = (Number(this.totalAmount) * PERCENTAGE) + FIXED_FEE;
            const stripeFeeIVA = stripeFee * TAX_RATE;
            const totalStripeFee = stripeFee + stripeFeeIVA;

            // Calcular montos finales
            const grossAmountWithoutMSI = Number(this.totalAmount) + totalStripeFee;

            // Calcular fee MSI con IVA
            const msiFee = grossAmountWithoutMSI * msiRate;
            const msiFeeIVA = msiFee * TAX_RATE; // IVA también se aplica al fee MSI
            const totalMsiFee = msiFee + msiFeeIVA;

            const grossAmount = grossAmountWithoutMSI + totalMsiFee;

            return parseFloat(grossAmount.toFixed(2));
        },

        calculateCashPayment(amount) {
            const { STRIPE } = PAYMENT_CONFIG;
            const { PERCENTAGE, FIXED_FEE, TAX_RATE } = STRIPE;

            // Limpiar y validar amount
            if (typeof amount === 'string') {
                amount = amount.replace(/[$,]/g, '');
            }
            amount = parseFloat(amount);

            // Calcular comisión Stripe
            const stripeFee = (amount * PERCENTAGE) + FIXED_FEE;
            const stripeFeeIVA = stripeFee * TAX_RATE;
            const totalStripeFee = stripeFee + stripeFeeIVA;

            return Number(amount) + Number(totalStripeFee);
        },

        // Procesamiento de pagos
        async handleSubmit() {
            // Validar nombre del tarjetahabiente
            if (!this.$refs.cardholderName.value || this.$refs.cardholderName.value.trim() === "") {
                await sweetAlert.fire({
                    icon: 'warning',
                    title: 'Nombre requerido',
                    text: 'Por favor, ingresa el nombre del tarjetahabiente antes de continuar.',
                });
                return;
            }

            // Preparar monto
            this.totalAmount = this.quoter.prima_total.replace("$", "").replace(",", "");
            this.setPaymentCookie(this.quoter, this.totalAmount);

            // Mostrar estado de carga
            this.isLoading = true;
            document.getElementById('card-button').innerHTML = 'Buscando MSI... <i class="fa fa-spinner fa-spin"></i>';

            try {
                // Crear método de pago
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card',
                    this.cardElement,
                    { billing_details: { name: this.$refs.cardholderName.value } },
                );

                if (error) {
                    console.error("Error al crear el método de pago:", error);
                    this.resetLoadingState();
                    return;
                }

                this.paymentMethodId = paymentMethod.id;

                // Consultar planes MSI disponibles
                const response = await this.fetchWithCSRF('/api/collect-details', {
                    payment_method_id: this.paymentMethodId,
                    amount: Math.round(this.totalAmount * 100) // Centavos
                });

                if (!response.ok) {
                    console.error("Error en la respuesta del servidor:", response.status);
                    this.resetLoadingState();
                    return;
                }

                const json = await response.json();

                if (json.error_message) {
                    console.error('Error del servidor:', json.error_message);
                    this.resetLoadingState();
                    return;
                }

                this.showDetails = false;
                this.intentId = json.intent_id;
                this.availablePlans = json.available_plans;

                // Manejar caso sin MSI disponibles
                if (this.availablePlans.length === 0) {
                    this.resetLoadingState();

                    const result = await sweetAlert.fire({
                        title: 'No hay meses sin intereses',
                        text: "Su tarjeta no tiene meses sin intereses disponibles. ¿Desea continuar con la compra?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, continuar',
                        cancelButtonText: 'No, cancelar'
                    });

                    if (result.isConfirmed) {
                        await this.confirmPaymentDirectly();
                    }
                } else {
                    this.resetLoadingState();
                }
            } catch (error) {
                console.error("Error en proceso de pago:", error);
                this.resetLoadingState();
            }
        },

        resetLoadingState() {
            this.isLoading = false;
            document.getElementById('card-button').innerHTML = 'Validar MSI';
        },

        async confirmPaymentDirectly() {
            try {
                const newAmountDirectly = Math.round(this.calculateCashPayment(this.totalAmount) * 100);
                this.setPaymentCookie(null, newAmountDirectly);

                const response = await this.fetchWithCSRF('/api/confirm-payment-directly', {
                    intent_id: this.intentId,
                    payment_method_id: this.paymentMethodId,
                    amount: newAmountDirectly,
                });

                if (!response.ok) {
                    console.error("Error al confirmar pago directo:", response.status);
                    return;
                }

                const json = await response.json();

                if (json.error_message) {
                    console.error('Error al confirmar pago:', json.error_message);
                    await sweetAlert.fire({
                        icon: 'error',
                        title: 'Pago rechazado',
                        text: json.error_message,
                    });
                    this.isConfirmingPayment = false;
                    return;
                }

                if (json.status === 'requires_action') {
                    const { paymentIntent, error } = await this.stripe.handleCardAction(json.client_secret);
                    if (error) {
                        console.error("Error 3DS Directo:", error);
                        await sweetAlert.fire({ icon: 'error', title: 'Error', text: error.message });
                        this.isConfirmingPayment = false;
                        this.isLoading = false;
                        document.getElementById('card-button').innerHTML = 'Validar MSI';
                    } else {
                        if (paymentIntent.status === 'succeeded') {
                             this.isPaymentConfirmed = true;
                             this.getAlert('confirm_payment');
                        } else {
                             await this.confirmPaymentDirectly();
                        }
                    }
                    return;
                }

                if (json.status === 'succeeded') {
                    this.isPaymentConfirmed = true;
                    this.getAlert('confirm_payment');
                }
            } catch (error) {
                console.error('Error al confirmar pago directo:', error);
            }
        },

        async confirmPaymentWithPlans() {
            // Validar selección de plan
            if (this.selectedPlan === null) {
                this.getAlert('no_msi');
                return;
            }

            this.isConfirmingPayment = true;

            let planSelected = '';
            let newAmount;

            // Determinar monto según tipo de pago
            if (this.selectedPlan === 'cash') {
                newAmount = Math.round(this.calculateCashPayment(this.totalAmount) * 100);
            } else {
                planSelected = this.availablePlans[this.selectedPlan];
                newAmount = Math.round(this.calculateTotalAmount(planSelected.count) * 100);
            }

            this.setPaymentCookie(null, newAmount);

            try {
                // Actualizar monto del PaymentIntent
                let response = await this.fetchWithCSRF('/api/update-payment', {
                    intent_id: this.intentId,
                    amount: newAmount
                });

                if (!response.ok) {
                    console.error("Error al actualizar pago:", response.status);
                    this.isConfirmingPayment = false;
                    return;
                }

                let json = await response.json();

                if (json.error_message) {
                    console.error('Error del servidor:', json.error_message);
                    this.isConfirmingPayment = false;
                    return;
                }

                if (this.selectedPlan === 'cash') {
                    // Confirmar pago directo (contado)
                    response = await this.fetchWithCSRF('/api/confirm-payment-directly', {
                        intent_id: this.intentId,
                        payment_method_id: this.paymentMethodId,
                        amount: newAmount
                    });
                } else {
                    // Confirmar pago con el plan seleccionado (MSI)
                    response = await this.fetchWithCSRF('/api/confirm-payment', {
                        intent_id: this.intentId,
                        plan: planSelected
                    });
                }

                if (!response.ok) {
                    console.error("Error al confirmar pago:", response.status);
                    this.isConfirmingPayment = false;
                    return;
                }

                json = await response.json();

                if (json.error_message) {
                    console.error('Error al confirmar pago:', json.error_message);
                    await sweetAlert.fire({
                        icon: 'error',
                        title: 'Pago rechazado',
                        text: json.error_message,
                    });
                    this.isConfirmingPayment = false;
                    return;
                }

                if (json.status === 'requires_action') {
                    const { paymentIntent, error } = await this.stripe.handleCardAction(json.client_secret);
                    if (error) {
                        console.error("Error en autenticación 3D Secure:", error);
                        await sweetAlert.fire({
                            icon: 'error',
                            title: 'Error de autenticación',
                            text: error.message,
                        });
                        this.isConfirmingPayment = false;
                    } else {
                        if (paymentIntent.status === 'succeeded') {
                            this.isPaymentConfirmed = true;
                            this.getAlert('confirm_payment');
                        } else {
                            // Reintentar confirmación
                            await this.confirmPaymentWithPlans();
                        }
                    }
                    return;
                }

                if (json.status === 'succeeded') {
                    this.isPaymentConfirmed = true;
                    this.getAlert('confirm_payment');
                } else {
                    this.isConfirmingPayment = false;
                }
            } catch (error) {
                console.error('Error en proceso de pago con planes:', error);
                this.isConfirmingPayment = false;
            }
        },

        // Utilidad para fetch con CSRF
        async fetchWithCSRF(url, data) {
            return fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(data)
            });
        }
    }
}
</script>

<style scoped>
#checkout-component {
    height: 100vh;
}

.blueText {
    color: #016AA9;
    font-size: 17px;
    line-height: normal;
}

hr.blackHr {
    background: #515151;
    border: 0;
    height: 1px;
    margin: 5px 0;
    text-align: left;
    width: 100%;
}

.StripeElement {
    box-shadow: 0 1px 3px 0 #e6ebf1;
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}

/* Clase para vh-100 solo en desktop */
@media (min-width: 768px) {
    .vh-100-desktop {
        height: 100vh !important;
    }
}

/* Estilos para el container de términos */
.terms-container {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.terms-container input[type="checkbox"] {
    margin-right: 0.5rem;
    margin-top: 0.25rem;
    flex-shrink: 0;
}

.terms-container label {
    cursor: pointer;
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 0;
    word-wrap: break-word;
}

/* Ajustes específicos para móvil */
@media (max-width: 767.98px) {
    #checkout-component {
        padding: 1rem 0;
        min-height: 100vh;
        height: auto;
    }

    .terms-container {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .terms-container label {
        font-size: 13px;
    }
}
</style>
